import React from "react";
import { useQuery } from "@tanstack/react-query";
import { getGallery } from "../Service/Api";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import LazyLoad from "react-lazyload";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Gallery = () => {
  // ✅ Fetch gallery data using React Query v5
  const { data: galleryData } = useQuery({
    queryKey: ["galleryData"],
    queryFn: getGallery,
  });

  // ✅ Fallback gallery content if no data available
  const empty = [
    { title: "St. Joseph’s school, Barhalganj " },
    { title: "St. Joseph’s school, Barhalganj " },
    { title: "St. Joseph’s school, Barhalganj " },
    { title: "St. Joseph’s school, Barhalganj " },
    { title: "St. Joseph’s school, Barhalganj " },
    { title: "St. Joseph’s school, Barhalganj " },
  ];

  // ✅ React Slick settings (keep layout unchanged)
  const settings = {
    autoplay: true,
    infinite: true,
    autoplaySpeed: 2000,
    speed: 1000,
    slidesToShow: 4,
    slidesToScroll: 1,
    initialSlide: 0,
    arrows: false,
    adaptiveHeight: true,
    responsive: [
      { breakpoint: 1300, settings: { slidesToShow: 3 } },
      { breakpoint: 992, settings: { slidesToShow: 2 } },
      { breakpoint: 767, settings: { slidesToShow: 1 } },
      { breakpoint: 480, settings: { slidesToShow: 1 } },
    ],
  };

  // ✅ Use data or fallback
  const galleryItems =
    galleryData && galleryData.length > 0
      ? galleryData.filter(function (item, index, arr) {
          return item.category === "PhotoGallery";
        })
      : empty;

  return (
    <>
      <Slider {...settings}>
        {galleryItems.map((item, index) => (
          <div className="item" key={index}>
            <div className="galleryimg">
              <div className="galleryimgbox">
                <LazyLoad
                  offset={10}
                  placeholder={
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SJSKBUP/public/Images/slider1.png"
                      alt="Loading..."
                      className="img-fluid"
                    />
                  }
                >
                  <img
                    src={
                      item.attachments && Array.isArray(item.attachments)
                        ? `https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${item.attachments[0]}`
                        : "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SJSKBUP/public/Images/slider1.png"
                    }
                    className="img-fluid"
                    alt={item.title || "Gallery"}
                  />
                </LazyLoad>

                <div className="gallerydesc">
                  <Link to="/GalleryInner" className="gallery_button">
                    View Gallery
                  </Link>
                  <h6>{item.title}</h6>
                </div>
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </>
  );
};

export default Gallery;
